export default (function (value) {
  return typeof value === 'string';
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isString.js
// module id = 692
// module chunks = 1